import { Component, Input } from '@angular/core';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-purchase-order-line-item]',
  template: `
    <td>{{lineItem?.part_detail?.name}}</td>
    <td>{{lineItem?.part_detail?.description}}</td>
    <td>{{lineItem?.reference}}</td>
    <td>{{lineItem?.quantity}}</td>
    <td>{{lineItem?.received}}</td>
    <td>{{lineItem?.supplier_part_detail?.packaging}}</td>
    <td>{{lineItem?.supplier_part_detail?.pack_quantity}}</td>
    <td>{{lineItem?.supplier_part_detail?.SKU}}</td>
    <td>{{lineItem?.purchase_price | currency}}</td>
    <td>{{lineItem?.total_price | currency}}</td>
    <td>{{lineItem?.target_date}}</td>
  `,
  styleUrls: []
})
export class TrPurchaseOrderLineItemComponent {
  @Input() lineItem: any;
  @Input() profile: any;
  @Input() permissions: any;

  constructor(
    public icons: IconsService,
  ) {}
}
